var map = {
	"./alchemisten": 81,
	"./alchemisten/": 81,
	"./alchemisten/assets/alchemisten-logo-big.svg": 146,
	"./alchemisten/assets/favicon.png": 113,
	"./alchemisten/assets/fonts/AlFresco.ttf": 149,
	"./alchemisten/assets/fonts/Cookie-Regular.ttf": 153,
	"./alchemisten/assets/fonts/MeieScript-Regular.ttf": 152,
	"./alchemisten/assets/fonts/Parisienne-Regular.ttf": 150,
	"./alchemisten/assets/fonts/Poppins-Regular.ttf": 147,
	"./alchemisten/assets/fonts/Poppins-SemiBold.ttf": 148,
	"./alchemisten/assets/fonts/Roboto-Light.ttf": 151,
	"./alchemisten/assets/fonts/Tangerine-Bold.ttf": 154,
	"./alchemisten/assets/images/birthday_high.png": 141,
	"./alchemisten/assets/images/christmas_high.png": 140,
	"./alchemisten/assets/images/easter_high.png": 142,
	"./alchemisten/assets/images/grief_high.png": 143,
	"./alchemisten/assets/images/invitation_high.png": 144,
	"./alchemisten/assets/images/marriage_high.png": 145,
	"./alchemisten/assets/images/watermark_high.png": 66,
	"./alchemisten/assets/images/watermark_high_white.png": 112,
	"./alchemisten/index": 81,
	"./alchemisten/index.ts": 81,
	"./alchemisten/render": 91,
	"./alchemisten/render.ts": 91,
	"./alchemisten/templates": 84,
	"./alchemisten/templates.ts": 84,
	"./alchemisten/templates/birthdayTemplateData": 86,
	"./alchemisten/templates/birthdayTemplateData.ts": 86,
	"./alchemisten/templates/christmasTemplateData": 85,
	"./alchemisten/templates/christmasTemplateData.ts": 85,
	"./alchemisten/templates/easterTemplateData": 87,
	"./alchemisten/templates/easterTemplateData.ts": 87,
	"./alchemisten/templates/griefTemplateData": 88,
	"./alchemisten/templates/griefTemplateData.ts": 88,
	"./alchemisten/templates/invitationTemplateData": 89,
	"./alchemisten/templates/invitationTemplateData.ts": 89,
	"./alchemisten/templates/marriageTemplateData": 90,
	"./alchemisten/templates/marriageTemplateData.ts": 90,
	"./alchemisten/templates/shared": 8,
	"./alchemisten/templates/shared.ts": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;